





































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import VatsAPI from '@/Shared/VatsAPI';
import buildEntityComponentMixin from '@/Shared/CommonEntityMixins/EntityComponentMixin';
import { LetterType } from '@/Letters/Enums';
import { Dictionary } from 'vue-router/types/router';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import { PaymentResult } from './PaymentResult';

const component = mixins(LocationBasedMixin, buildEntityComponentMixin<PaymentResult>()).extend({
    props: {
        responseId: {
            required: false,
            type: String
        },
        result: {
            required: false,
            type: Object as () => PaymentResult | null
        }
    },
    beforeMount() {
        if (this.responseId) {
            this.loadEntity();
        }
        else if (this.result) {
            this.entity = this.result;
        }
    },
    data() {
        return {
            i18nPrefix: 'payment.paymentCompletion',
            emailAddress: null as null | string,
            LetterType,
            validationErrors: {} as Dictionary<string[]>,
            emailing: false,
            loadBeforeMount: false
        };
    },
    computed: {
        entityUrls(): string {
            return `${this.location}/Payments/ProcessorResponse/${this.responseId}`;
        }
    },
    methods: {
        async sendEmail() {
            this.validationErrors = {};
            this.emailing = true;
            try {
                const url = `${this.location}/Letters/${LetterType.PaymentReceipt}/${this.entity.receiptId}/Email`;
                await VatsAPI.post(url, JSON.stringify(this.emailAddress), {
                    headers: {
                        ['content-type']: 'application/json',
                    },
                });

                const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.emailSuccessfulTitle`);
                const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.emailSuccessfulMessage`, {
                    address: this.emailAddress
                });
                this.$bvToast.toast(translatedMessage.toString(), {
                    title: translatedTitle.toString(),
                    autoHideDelay: 5000
                });
            }
            catch (e) {
                this.validationErrors = getValidationErrors(e.response);
                const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.emailFailedTitle`);
                const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.emailFailedMessage`);
                this.$bvToast.toast(translatedMessage.toString(), {
                    title: translatedTitle.toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
            finally {
                this.emailing = false;
            }
        }
    }
});

export default component;
